<script>
export default {
    methods: {
        generateId() {
            return Math.random().toString().replace('0.', '');
        },
    },
};
</script>
